/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Resource action required identifier. 
*/
export enum ActionRequiredDetails {
  CloudResourceActionRequiredUnspecified = 'CLOUD_RESOURCE_ACTION_REQUIRED_UNSPECIFIED',
  AzureSqlVmInvalidConfiguration = 'AZURE_SQL_VM_INVALID_CONFIGURATION',
  DynamoDbInvalidStreamViewType = 'DYNAMO_DB_INVALID_STREAM_VIEW_TYPE',
  DynamoDbInsufficientRcus = 'DYNAMO_DB_INSUFFICIENT_RCUS',
  RdsDatabaseStopped = 'RDS_DATABASE_STOPPED',
  BigqueryChangeHistoryDisabled = 'BIGQUERY_CHANGE_HISTORY_DISABLED',
  ObjectStoreInventoryRequired = 'OBJECT_STORE_INVENTORY_REQUIRED',
  CloudSqlDatabaseStopped = 'CLOUD_SQL_DATABASE_STOPPED',
  RdsGlobalDbSecondaryCluster = 'RDS_GLOBAL_DB_SECONDARY_CLUSTER',
  SapHanaBackupNotConfigured = 'SAP_HANA_BACKUP_NOT_CONFIGURED',
  KeyspacesCdcNotEnabled = 'KEYSPACES_CDC_NOT_ENABLED',
  AwsNativePitrPermissionsMissing = 'AWS_NATIVE_PITR_PERMISSIONS_MISSING',
  RdsManagedByExternalBackupPlan = 'RDS_MANAGED_BY_EXTERNAL_BACKUP_PLAN',
  SapHanaAgentApplicationNotOnboarded = 'SAP_HANA_AGENT_APPLICATION_NOT_ONBOARDED'
}
